import { http } from '../../config/axios'

export default function postClient(client: any): Promise<string> {
  return http
    .post('api/client', client)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post client', error)
      throw Error(error.response.data)
    })
}
